import styled from 'styled-components'
import { Button as AntButton, Typography, Form } from 'antd'
import { MailOutlined } from '@ant-design/icons'
import { SPACING, COLORS, TYPOGRAPHY } from '../../../styles/theme'

const { Text: AntText } = Typography

/**
 * Styled components for ForgotPasswordForm component
 * Replaces inline styles with reusable styled components
 */

// Centered container for success message
export const CenteredContainer = styled.div`
  text-align: center;
`

// Large mail icon for success state
export const LargeMailIcon = styled(MailOutlined)`
  font-size: ${TYPOGRAPHY.h1.fontSize};
  color: ${COLORS.primary};
  margin-bottom: ${SPACING.lg};
`

// Title with bottom margin
export const SuccessTitle = styled(Typography.Title)`
  &.ant-typography {
    margin-bottom: ${SPACING.sm};
  }
`

// Secondary text with block display and bottom margin
export const SecondaryText = styled(AntText)`
  display: block;
  margin-bottom: ${SPACING.xl};
`

// Secondary text with smaller font size for additional info
export const SmallSecondaryText = styled(AntText)`
  display: block;
  margin-bottom: ${SPACING.xl};
  font-size: ${TYPOGRAPHY.body.fontSize};
`

// Form item with reduced bottom margin
export const FormItemReduced = styled(Form.Item)`
  margin-bottom: ${SPACING.md};
`

// Form item with no bottom margin
export const FormItemNoMargin = styled(Form.Item)`
  margin-bottom: 0;
`

// Full width button
export const FullWidthButton = styled(AntButton)`
  width: 100%;
`

// Link button with zero padding and auto height
export const LinkButton = styled(AntButton)`
  padding: 0;
  height: auto;
`
